import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RevokeRecordDialog from './modals/RevokeRecordDialog';
import ArchiveRecordDialog from './modals/ArchiveRecordDialog';
import GetEmailDialog from './modals/GetEmailDialog';
import EditPatientDialog from './modals/EditPatientDialog';
import UpdateAssignedDocument from './modals/UpdateAssignedDocumentDialog';
import UpdateReferralDialog from './modals/UpdateReferralDialog';
import SecureLinkDialog from './modals/SecureLinkDialog';
import ResendRecordDialog from './modals/ResendRecordDialog';
import LogoutUserDialog from './modals/LogoutUserDialog';
import UploadRecordDialog from './modals/UploadRecordDialog';
import ChangeEMRDialog from './modals/ChangeEMRDialog';
import RaiseFlagDialog from './modals/RaiseFlagDialog';
import DownloadZipDialog from './modals/DownloadZipDialog';
import NotifyDialog from './modals/NotifyDialog';
import TransferToDepartmentDialog from './modals/TransferToDepartmentDialog';
import AddLabelToRecordDialog from './modals/AddLabelToRecordDialog';
import AddLabelToMultipleRecordsDialog from './modals/AddLabelToMultipleRecordsDialog';
import CreateNewChartDialog from './modals/CreateNewChartDialog';
import AddLabelDialog from './modals/AddLabelDialog';
import AddTeamDialog from './modals/AddTeamDialog';
import AddCategoryDialog from './modals/AddCategoryDialog';
import AddTaskTemplateDialog from './modals/AddTaskTemplateDialog';
import AddTaskProviderDialog from './modals/AddTaskProviderDialog';
import ReplyToEmailDialog from './modals/ReplyToEmailDialog';
import AddNewUserDilaog from './modals/AddNewUserDialog';
import UpgradeBrowserDialog from './modals/UpgradeBrowserDialog';
import FailedSSODialog from './modals/FailedSSODialog';
import ProviderSwitchedDialog from './modals/ProviderSwitchedDialog';
import AddFaxNumberDialog from './modals/AddFaxNumberDialog';
import FaxNumberInstructionsDialog from './modals/FaxNumberInstructionsDialog';
import SubmitFormDialog from './modals/SubmitFormDialog';
import MessageModal from '../components/modal/MessageModal';
import SplitSelectedRecordDialog from './modals/SplitSelectedRecordDialog';
import AutoUploadDialog from './modals/AutoUploadDialog';
import SelectOrganization from './modals/SelectOrganizationDialog';
import UpdatePhoneNumberDialog from './modals/UpdatePhoneNumberDialog';
import CreateTaskDialog from './modals/CreateTaskDialog';
import AssignRecordDialog from './modals/AssignRecordDialog';
import AssignMultipleRecordsDialog from './modals/AssignMultipleRecordsDialog';
import SmsMessageDialog from './modals/SmsMessageDialog';
import MairaCallConfirmDialog from './modals/MairaCallConfirmDialog';
import ReferralReplyDialog from './modals/ReferralReplyDialog';
import ShareReferralDialog from './modals/ShareReferralDialog';
import InvitePartnerDialog from './modals/InvitePartnerDialog';
import SharedReferralDrawerDialog from './modals/SharedReferralDrawerDialog';
import LinkReferralDialog from './modals/LinkReferralDialog';
import ReferralArchiveWarningDialog from './modals/ReferralArchiveWarningDialog';
import MergeRecordsConfirmDialog from './modals/MergeRecordsConfirmDialog';
import MoveToReferralManagementDialog from './modals/MoveToReferralManagementDialog';
import AutoSplitModal from '../components/autoSplit/AutoSplitModal';
import MacPrinterDriverAnnouncement from '../components/modal/MacPrinterDriverAnnouncement';

import { hideModal } from '../actions/modal';

const MODAL_COMPONENTS = {
  ARCHIVE_RECORD: ArchiveRecordDialog,
  REVOKE_RECORDS: RevokeRecordDialog,
  UPLOAD_RECORD: UploadRecordDialog,
  GET_EMAIL: GetEmailDialog,
  EDIT_PATIENT: EditPatientDialog,
  UPDATE_ASSIGNED_DOCUMENT: UpdateAssignedDocument,
  UPDATE_REFERRAL: UpdateReferralDialog,
  SPLIT_SELECTED_RECORD: SplitSelectedRecordDialog,
  SECURE_LINK: SecureLinkDialog,
  RESEND_RECORD: ResendRecordDialog,
  LOGOUT_USER: LogoutUserDialog,
  RAISE_FLAG: RaiseFlagDialog,
  DOWNLOAD_ZIP: DownloadZipDialog,
  NOTIFY: NotifyDialog,
  TRANSFER_TO_DEPARTMENT: TransferToDepartmentDialog,
  ADD_LABEL_TO_RECORD: AddLabelToRecordDialog,
  ADD_LABEL_TO_MULTIPLE_RECORDS: AddLabelToMultipleRecordsDialog,
  CREATE_NEW_CHART: CreateNewChartDialog,
  CREATE_TASK: CreateTaskDialog,
  ASSIGN_RECORD: AssignRecordDialog,
  ASSIGN_MULTIPLE_RECORDS: AssignMultipleRecordsDialog,
  ADD_LABEL: AddLabelDialog,
  ADD_TEAM: AddTeamDialog,
  ADD_CATEGORY: AddCategoryDialog,
  ADD_TASK_TEMPLATE: AddTaskTemplateDialog,
  ADD_TASK_PROVIDER: AddTaskProviderDialog,
  REPLY_TO_EMAIL: ReplyToEmailDialog,
  ADD_NEW_USER: AddNewUserDilaog,
  UPGRADE_BROWSER: UpgradeBrowserDialog,
  ADD_FAX_NUMBER: AddFaxNumberDialog,
  MESSAGE_MODAL: MessageModal,
  EXISTING_ACCOUNT: FailedSSODialog,
  PROVIDER_SWITCHED: ProviderSwitchedDialog,
  FAX_NUMBER_INSTRUCTIONS: FaxNumberInstructionsDialog,
  SUBMIT_FORM: SubmitFormDialog,
  CHANGE_EMR: ChangeEMRDialog,
  AUTO_UPLOAD: AutoUploadDialog,
  SELECT_ORGANIZATION: SelectOrganization,
  UPDATE_PHONE_NUMBER: UpdatePhoneNumberDialog,
  SMS_MESSAGE: SmsMessageDialog,
  MAIRA_CALL: MairaCallConfirmDialog,
  REFERRAL_REPLY: ReferralReplyDialog,
  SHARE_REFERRAL: ShareReferralDialog,
  INVITE_PARTNER: InvitePartnerDialog,
  SHARED_REFERRAL_DRAWER: SharedReferralDrawerDialog,
  LINK_REFERRAL: LinkReferralDialog,
  REFERRAL_ARCHIVE_WARNING: ReferralArchiveWarningDialog,
  MERGE_RECORDS_CONFIRM: MergeRecordsConfirmDialog,
  MOVE_TO_REFERRAL_MANAGEMENT: MoveToReferralManagementDialog,
  AUTO_SPLIT_SUGGESTION: AutoSplitModal,
  MAC_PRINTER_DRIVER_ANNOUNCEMENT: MacPrinterDriverAnnouncement,
};

class ModalRoot extends Component {
  modalType = () => {
    if (!this.props.modalType.type) return null;

    const SpecificModal = MODAL_COMPONENTS[this.props.modalType.type];
    if (!SpecificModal) {
      return null;
    }

    // Key the modal to the record it was opened for so switching records (e.g.
    // move-to-next-record) remounts a fresh instance instead of reusing one whose
    // state still belongs to the previous patient. `data` can be null, so guard it.
    const { data, type } = this.props.modalType;
    const recordKey = [
      type,
      data?.patient?.file_token,
      data?.sendToken,
      data?.record?.file_token || data?.record,
    ].filter(Boolean).join('|');

    return (
      <SpecificModal
        key={recordKey}
        {...this.props}
      />
    );
  }

  render() {
    return (
      <>
        {this.modalType()}
      </>
    );
  }
}

ModalRoot.propTypes = {
  modalType: PropTypes.object.isRequired,
};

export default connect(state => ({
  modalType: state.modal.modalType,
}),
{ hideModal })(ModalRoot);
